<template>
  <v-layout row wrap>
    <v-flex md3 sm6 xs12  v-if="showCompanyOverview">
      <v-card class="small-box" dark color="#363636">
        <v-card-title class="title">Total Companies</v-card-title>
        <v-card-text class="pt-3">
          <h3>{{totalCompanies}}</h3>
          <div class="icon pt-5">
            <i class="ion ion-ios-business" style="color:#c3c3c3"></i>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex md3 sm6 xs12  v-if="showCampaignOverview">
      <v-card class="small-box" dark color="#363636">
        <v-card-title class="title">Total Campaigns</v-card-title>
        <v-card-text class="pt-3">
          <h3>{{totalCampaigns}}</h3>
          <div class="icon pt-5">
            <i class="ion ion-ios-stats" style="color:#c3c3c3"></i>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex md3 sm6 xs12 v-if="showInfluencerOverview">
      <v-card class="small-box" dark color="#363636">
        <v-card-title class="title">Total Influencers</v-card-title>
        <v-card-text class="pt-3">
          <h3>{{totalInfluencers}}</h3>
          <div class="icon pt-5">
            <i class="ion ion-ios-people" style="color:#c3c3c3"></i>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex md3 sm6 xs12 v-if="showClientOverview">
      <v-card class="small-box" dark color="#363636">
        <v-card-title class="title">Total Clients</v-card-title>
        <v-card-text class="pt-3">
          <h3>{{totalClients}}</h3>
          <div class="icon pt-5">
            <i class="ion ion-ios-contacts" style="color:#c3c3c3"></i>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import KobeOverViewHelper from './KobeOverviewHelper'
import config from '@/config'

export default {
  props: {
    userRole: Number
  },
  data() {
    return {
      totalInfluencers: 0,
      totalClients: 0,
      totalCompanies: 0,
      totalCampaigns: 0,
      showInfluencerOverview: false,
      showClientOverview: false,
      showCompanyOverview: false,
      showCampaignOverview: false
    }
  },
  methods: {
    loadData() {
      if (this.userRole === config.userRoles.CLIENT) {
        // currently disable for Client
        this.loadTotalCampaigns()
      } else if (this.userRole === config.userRoles.AD_STRATEGIST || this.userRole === config.userRoles.FINANCE || this.userRole === config.userRoles.ACCOUNT_MANAGER) {
        this.loadTotalCampaigns()
        this.loadTotalInfluencers()
        this.loadTotalClients()
      } else if (this.userRole === config.userRoles.SUPER_ADMIN_HIGH || this.userRole === config.userRoles.SUPER_ADMIN_LOW) {
        this.loadTotalCampaigns()
        this.loadTotalInfluencers()
        this.loadTotalClients()
        this.loadTotalCompanies()
      }
    },
    loadTotalInfluencers() {
      KobeOverViewHelper
        .getTotalInfluencers()
        .then(response => {
          this.totalInfluencers = response
          this.showInfluencerOverview = true
        })
        .catch(() => {
          this.showInfluencerOverview = false
        })
    },
    loadTotalClients() {
      KobeOverViewHelper
        .getTotalClients()
        .then(response => {
          this.totalClients = response
          this.showClientOverview = true
        })
        .catch(() => {
          this.showClientOverview = false
        })
    },
    loadTotalCampaigns() {
      KobeOverViewHelper
        .getTotalCampaigns()
        .then(response => {
          this.totalCampaigns = response
          this.showCampaignOverview = true
        })
        .catch(() => {
          this.showCampaignOverview = false
        })
    },
    loadTotalCompanies() {
      KobeOverViewHelper
        .getTotalCompanies()
        .then(response => {
          this.totalCompanies = response
          this.showCompanyOverview = true
        })
        .catch(() => {
          this.showCompanyOverview = false
        })
    }
  },
  watch: {
    userRole: () => this.loadData()
  },
  mounted() {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// KobeOverview.vue?522dcf8c